'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gdprExplicitConsentRequired = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _getMessage = require('./getMessage');

var _getGdprExplicitConsentRequired = require('../message/getGdprExplicitConsentRequired');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gdprExplicitConsentRequired = exports.gdprExplicitConsentRequired = (0, _pipe2.default)(_getMessage.getMessage, _getGdprExplicitConsentRequired.getGdprExplicitConsentRequired);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/widget-data/gdprExplicitConsentRequired.js
// module id = 208
// module chunks = 2 3